import styled from 'styled-components';

const SharpyThankYouStyle = styled.div`
	&.sharpyThankYou {
		.style1 {
			fill: none;
			stroke: var(--color2);
			stroke-linecap: round;
			stroke-linejoin: round;
			stroke-width: 3px;
		}

		.body {
			fill: var(--color2);
		}

		.style2 {
			fill: var(--color1);
		}

		.hideOpacity {
			opacity: 0;
		}

		.style3 {
			fill: none;
			stroke: var(--color1);
			stroke-linecap: round;
			stroke-linejoin: round;
			stroke-width: 3px;
		}

		.fillNone {
			fill: none;
		}
	}
`;
export default SharpyThankYouStyle;
